import { FareType } from '../../../typesFinancial';

// Desfecho da transmissão ao RM ao lado do status da tarifa. Tarifa confirmada
// antes de o protocolo passar a ser persistido não tem `rm_record_key`, e isso
// é normal: nesse caso não se exibe nada, nem espaço vazio nem erro.
export function FareTransmissionDetail(props: { fare: FareType }) {
  const { fare } = props;

  if (
    (fare.status === 'BILLED' || fare.status === 'REBILLED') &&
    fare.is_exempt &&
    !fare.rm_record_key
  ) {
    return (
      <span style={{ color: 'var(--neutral_medium)', fontSize: '12px' }}>
        Sem envio ao RM
      </span>
    );
  }

  if (
    (fare.status === 'BILLED' || fare.status === 'REBILLED') &&
    fare.rm_record_key
  ) {
    return (
      <span style={{ color: 'var(--neutral_medium)', fontSize: '12px' }}>
        Protocolo {fare.rm_record_key}
      </span>
    );
  }

  return null;
}
